import { render, staticRenderFns } from "./LabReport.vue?vue&type=template&id=198683dd&scoped=true"
import script from "./LabReport.vue?vue&type=script&lang=js"
export * from "./LabReport.vue?vue&type=script&lang=js"
import style0 from "./LabReport.vue?vue&type=style&index=0&id=198683dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198683dd",
  null
  
)

export default component.exports